import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const AssetFilters = ({ searchQuery, onSearchChange, activeFilter, onFilterChange, sortBy, onSortChange }) => {
  const filters = [
    { id: 'all', label: 'All Files', icon: 'Files', count: 248 },
    { id: 'images', label: 'Images', icon: 'Image', count: 156 },
    { id: 'videos', label: 'Videos', icon: 'Video', count: 32 },
    { id: 'documents', label: 'Documents', icon: 'FileText', count: 45 },
    { id: 'icons', label: 'Icons', icon: 'Sparkles', count: 15 }
  ];

  const sortOptions = [
    { value: 'date-desc', label: 'Newest First' },
    { value: 'date-asc', label: 'Oldest First' },
    { value: 'name-asc', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' },
    { value: 'size-desc', label: 'Largest First' },
    { value: 'size-asc', label: 'Smallest First' }
  ];

  return (
    <div className="bg-card border-b border-border p-4 space-y-4">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search assets by name, tag, or format..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>

        <div className="flex items-center gap-2">
          <Icon name="ArrowUpDown" size={16} className="text-muted-foreground" />
          <select
            value={sortBy}
            onChange={(e) => onSortChange(e?.target?.value)}
            className="px-3 py-2 bg-background border border-border rounded-lg caption text-foreground focus:outline-none focus:ring-2 focus:ring-primary transition-all duration-250"
          >
            {sortOptions?.map((option) => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {filters?.map((filter) => (
          <button
            key={filter?.id}
            onClick={() => onFilterChange(filter?.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-250 ${
              activeFilter === filter?.id
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground'
            }`}
          >
            <Icon name={filter?.icon} size={16} />
            <span className="caption font-medium">{filter?.label}</span>
            <span className={`text-xs px-1.5 py-0.5 rounded ${
              activeFilter === filter?.id
                ? 'bg-primary-foreground/20'
                : 'bg-background'
            }`}>
              {filter?.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AssetFilters;